// extracted by mini-css-extract-plugin
module.exports = {"groupedContainer":"form-builder-context_groupedContainer__1DyUF","label":"form-builder-context_label__1aaLv"};